 import React from 'react'
 import './Cards.css'
 import Cardslist from './Cardslist' 
 
 export default function Gallery() {
   return (
     
     <Cardslist/>
   )
 }
 